export default {"src":"/_next/static/media/mobile_white.817204fc.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};